import { TCreateConverter, TDeleteConverter, TFetchConverter } from '../types/converter.types';
import {
  TAddRecipientDB,
  TAddRecipientsDB,
  TAddRecipientsUI,
  TAddRecipientUI,
  TDeleteRecipientDB,
  TDeleteRecipientUI,
  TEditRecipientDetailsDB,
  TEditRecipientDetailsUI,
  TPetChargeReportDB,
  TPetChargeReportUI,
  TRecipientCandidateDB,
  TRecipientCandidateUI,
  TScheduleItemDB,
  TScheduleItemUI,
  TScheduleRecipientDB,
  TScheduleRecipientUI,
} from '../types/reporting.types';

export const scheduleRecipientConverter: TFetchConverter<TScheduleRecipientUI, TScheduleRecipientDB> = {
  fromDb: (data) => ({
    recipientName: data.recipientName || '',
    recipientId: data.recipientId,
    reportSchedule: data.reportSchedule,
    profilePicture: data.profilePicture || '',
    dayOfMonth: data.dayOfMonth,
    deliveryTime: data.deliveryTime,
    timezone: data.timezone,
  }),
};

export const scheduleItemConverter: TFetchConverter<TScheduleItemUI, TScheduleItemDB> = {
  fromDb: (data) => ({
    propertyId: data.propertyId,
    propertyName: data.propertyName || '',
    recipients:
      data.recipients
        ?.map((recipient) => scheduleRecipientConverter.fromDb(recipient))
        .sort((a, b) => a.recipientName.localeCompare(b.recipientName)) || [],
    on: data.on,
  }),
};

export const addRecipientsConverter: TCreateConverter<TAddRecipientsUI, TAddRecipientsDB> = {
  toDb: (data) => {
    return {
      propertyId: data.propertyId,
      recipients: data.recipients?.map((recipient) => addRecipientConverter.toDb(recipient)) || [],
    };
  },
};

export const addRecipientConverter: TCreateConverter<TAddRecipientUI, TAddRecipientDB> = {
  toDb: (data) => {
    return {
      propertyManagerId: data.propertyManagerId,
      reportSchedule: data.reportSchedule,
      dayOfMonth: data.dayOfMonth,
      deliveryTime: data.deliveryTime,
      timezone: data.timezone,
    };
  },
};

export const recipientCandidateConverter: TFetchConverter<TRecipientCandidateUI, TRecipientCandidateDB> = {
  fromDb: (data) => ({
    teamMemberId: data.teamMemberId,
    fullName: data.fullName || '',
    scheduled: data.scheduled,
  }),
};

export const deleteRecipientConverter: TDeleteConverter<TDeleteRecipientUI, TDeleteRecipientDB> = {
  toDb: (data) => ({
    propertyId: data.propertyId,
    recipientIds: data.recipientIds,
  }),
};

export const editRecipientDetailsConverter: TCreateConverter<TEditRecipientDetailsUI, TEditRecipientDetailsDB> = {
  toDb: (data) => ({
    propertyId: data.propertyId,
    reportRecipientConfigurationDTO: {
      propertyManagerId: data.recipientId,
      reportSchedule: data.schedule,
      dayOfMonth: data.dayOfMonth,
      deliveryTime: data.deliveryTime,
      timezone: data.timezone,
    },
  }),
};

export const generatePetChargeReportConverter: TCreateConverter<TPetChargeReportUI, TPetChargeReportDB> = {
  toDb: (data) => {
    return {
      ...(data.propertyIds && {
        propertyIds: data.propertyIds.map((item) => item.value),
      }),
      isYardiReport: data.isYardiReport,
    };
  },
};
